<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isExpand = computed(() => store.state.Config.isExpand);
</script>

<template>
  <div id="analyse">
    <div :class="['right-wp', isExpand ? 'expand' : '']">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#analyse {
  min-height: calc(100vh - 60px);
  display: flex;
  overflow-x: hidden;
  .right-wp {
    flex: 1;
    width: calc(100vw - 166px);
    background-color: var(--theme-bg-color);
  }
  .right-wp.expand {
    width: calc(100vw - 266px);
  }
}
</style>
